<template>
  <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      min-width="290px"
      offset-y
      transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
          v-model="formattedDate"
          :append-icon="textFieldAppendIcon"
          :class="textFieldClass"
          :clearable="clearable"
          :disabled="loadingData"
          :hide-details="hideDetails"
          :label="label"
          :placeholder="placeholder"
          dense
          outlined
          readonly
          v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker v-model="model" :locale="locale" :range="range" no-title>
      <v-spacer></v-spacer>
      <v-btn
          color="primary"
          text
          @click="menu = false"
      >{{ $t('components.modal.btn.cancel') }}
      </v-btn>
      <v-btn color="primary" text @click="$refs.menu.save(model)">OK</v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import moment from 'moment'
import { EventBus } from '../event-bus'

export default {
  name: 'DateFilter',
  data () {
    return {
      menu: false,
      formattedDate: undefined
    }
  },
  props: {
    loadingData: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Array, String]
    },
    placeholder: {
      type: String
    },
    label: {
      type: String
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    textFieldClass: {
      type: String,
      default: ''
    },
    range: {
      type: Boolean,
      default: true
    },
    textFieldAppendIcon: {
      type: String,
      default: ''
    }
  },
  watch: {
    menu: {
      handler () {
        this.$emit('validateDate')
      }
    },
    formattedDate: {
      handler () {
        if (this.formattedDate == null) {
          this.model = Array.isArray(this.model) ? [] : undefined
          this.$emit('resetDate')
        }
      }
    },
    model: {
      handler () {
        this.formatDate(this.value)
      }
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    locale () {
      return this.$i18n.locale
    }
  },
  mounted () {
    EventBus.$on('closeDatePicker', () => {
      this.menu = false
    })
    EventBus.$on('resetForm', () => {
      this.formattedDate = undefined
      this.model = undefined
    })
    this.formatDate(this.value)
  },
  methods: {
    formatDate (dates) {
      if (dates) {
        if (Array.isArray(dates)) {

          let copyDates = Object.assign([], dates)

          let sortedDates = copyDates.sort((a, b) => {
            return new Date(a) - new Date(b)
          })

          let formatedDates = []
          for (let date of sortedDates) {
            formatedDates.push(moment(date).format('L').replaceAll('/', '-'))
          }

          this.formattedDate = formatedDates

        } else {
          this.formattedDate = moment(dates).format('L').replaceAll('/', '-')
        }
      } else {
        this.formattedDate = undefined
      }
    }
  }
}
</script>
